import { extractAddressComponents } from 'components/forms/utils/extractAddressComponents';

type Autocomplete = google.maps.places.Autocomplete;
export type Place = ReturnType<Autocomplete['getPlace']>;

export default (
  place: Place = {},
  latlng: {
    lat?: number;
    lng?: number;
  } = {}
) => {
  const addressComponents = place.address_components;
  const components = extractAddressComponents(addressComponents);

  const {
    street_number,
    route,
    neighborhood,
    locality,
    sublocality_level_1,
    sublocality_level_2,
    administrative_area_level_3,
    administrative_area_level_2,
    administrative_area_level_1,
    country,
    postal_code,
  } = components;

  const { lat, lng } = latlng;

  const location = {
    street_1: `${street_number || ''} ${route || ''}`,
    street_2: '',
    city: locality || sublocality_level_1 || sublocality_level_2 || neighborhood || administrative_area_level_3,
    state: administrative_area_level_1,
    postal_code: postal_code || '00000',
    country_code: (country && country.short_name) || '',
    country_name: (country && country.long_name) || '',
    county_name: administrative_area_level_2,
    latitude: lat,
    longitude: lng,

    street_number,
    route,
  };

  return location;
};
